module.exports = __webpack_public_path__ + "img/asap.d4fa64d9.svg";